export enum GameTemplatesEnum {
  default = 'default',
  ctm = 'ctm',
  ct = 'ct',
  warfare = 'warfare',
  trivialWarfare = 'Trivial Warfare',
  triviaMaticManagerBlankGame = 'triviamanagerblank'
}
